import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🥟</span>
          <span className="brand-text">Parada Predileta</span>
        </Link>

        <button className="navbar-toggle" onClick={() => setOpen(!open)}>
          {open ? '✕' : '☰'}
        </button>

        <nav className={`navbar-nav ${open ? 'open' : ''}`}>
          <NavLink to="/" end onClick={() => setOpen(false)}>Início</NavLink>
          <NavLink to="/cardapio" onClick={() => setOpen(false)}>Cardápio</NavLink>
          <NavLink to="/localizacao" onClick={() => setOpen(false)}>Localização</NavLink>
          <NavLink to="/contato" onClick={() => setOpen(false)}>Contato</NavLink>
          <Link to="/admin" className="nav-admin-btn" onClick={() => setOpen(false)}>Painel Admin</Link>
        </nav>
      </div>
    </header>
  );
}
